var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatePickerCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98333 0.0961914C4.37626 0.0961914 4.69479 0.414722 4.69479 0.80765V1.51911H9.675V0.80765C9.675 0.414722 9.99353 0.0961914 10.3865 0.0961914C10.7794 0.0961914 11.0979 0.414722 11.0979 0.80765V1.53667C12.8955 1.71515 14.2995 3.23182 14.2995 5.0764V11.4795C14.2995 13.4442 12.7068 15.0368 10.7422 15.0368H3.6276C1.66297 15.0368 0.0703125 13.4442 0.0703125 11.4795V5.0764C0.0703125 3.23182 1.47426 1.71515 3.27187 1.53667V0.80765C3.27187 0.414722 3.59041 0.0961914 3.98333 0.0961914ZM1.61468 4.36494H12.7551C12.4621 3.53596 11.6715 2.94202 10.7422 2.94202H3.6276C2.69828 2.94202 1.90768 3.53596 1.61468 4.36494ZM12.8766 5.78786H1.49323V11.4795C1.49323 12.6583 2.44882 13.6139 3.6276 13.6139H10.7422C11.921 13.6139 12.8766 12.6583 12.8766 11.4795V5.78786ZM2.91615 7.92223C2.91615 7.52931 3.23468 7.21077 3.6276 7.21077H10.7422C11.1351 7.21077 11.4536 7.52931 11.4536 7.92223C11.4536 8.31516 11.1351 8.63369 10.7422 8.63369H3.6276C3.23468 8.63369 2.91615 8.31516 2.91615 7.92223Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerCalenderIcon);
export default __webpack_public_path__ + "static/media/datePickerCalenderIcon.c08fb87da91384e6cf9f116f2a9b8cd8.svg";
export { ForwardRef as ReactComponent };